import useApi from "./useApiRequest";
import { useMutation, useQuery } from "react-query";

export const GetPartesRevisiones = (id, resources = false, visualizador = false)  => {
    const api = useApi();
    return useQuery(['revisiones', id], async () => {
        const { data } = await api.get(`/partes-revisiones/${id}?resources=${resources}&visualizador=${visualizador}`);
        return data?.data;
    }, {
        refetchOnWindowFocus: false,
        retry: false,
        enabled: !!id
    });
}

export const GetResourcesRevisiones = (id)  => {
    const api = useApi();
    return useQuery(['res_revisiones', id], async () => {
        const { data } = await api.get(`/partes-revisiones/recursos/${id}`);
        return data?.data;
    }, {
        refetchOnWindowFocus: false,
        retry: false,
        enabled: !!id
    });
}

export const GetAllResourcesRevisiones = (id)  => {
    const api = useApi();
    return useQuery(['all_res_revisiones', id], async () => {
        const { data } = await api.get(`/partes-revisiones/recursos/complete/${id}`);
        return data?.data;
    }, {
        refetchOnWindowFocus: false,
        retry: false,
        enabled: !!id
    });
}

export const GetLastResourcesRevisiones = (id)  => {
    const api = useApi();
    return useQuery(['last_res_revisiones', id], async () => {
        const { data } = await api.get(`/partes-revisiones/last/${id}`);
        return data?.data;
    }, {
        refetchOnWindowFocus: false,
        retry: false,
        enabled: !!id
    });
}

export const CreateRevisiones = () => {
  const api = useApi();

  const mutate = async (params) => {
    const { data } = await api.post(`/partes-revisiones`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data;
  };

  const mutation = useMutation(mutate);

  return {
    createRevisionesMutation: mutation.mutate,
  };
};

export const UpdateRevision = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.put(`/partes-revisiones/${params.id}`, params.data, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        updateRevisionMutation: mutation.mutate,
    };
}
